import h from 'hyperscript';
import Control from 'ol/control/Control';

/* necessary for progress spinner icon to load correctly. */
import 'ui/progress-spinner/progress-spinner';

import type { Map } from 'cadenza/map/map';

interface MapProgressSpinnerOptions {
  element?: HTMLElement;
  target?: HTMLElement | string;
  shouldUpdateControlVisibility?: boolean;
}

/**
 * Map progress spinner appears when the map starts loading and disappears when loading is finished.
 */
export class MapProgressSpinner extends Control {

  /**
   * @property counter A counter which is increased on each call of show() and decreased on each call of hide()
   */
  _counter = 0;

  _shouldUpdateControlVisibility;

  constructor ({
    element = h<HTMLElement>('d-progress-spinner.d-map-progress-spinner.position-centered.ol-unselectable.ol-control', { hidden: true }),
    target,
    shouldUpdateControlVisibility = true
  }: MapProgressSpinnerOptions = {}) {
    super({ element, target });
    this._shouldUpdateControlVisibility = shouldUpdateControlVisibility;
  }

  override setMap (map: Map) {
    super.setMap(map);
    if (map != null) {
      map.on('loadstart', () => this.show());
      map.on('loadend', () => this.hide());
    }
  }

  // show and hide methods are still called in classic-map-context.js
  show () {
    this._counter++;
    this._updateControlVisibility();
  }

  hide () {
    if (this.visible) {
      this._counter--;
      this._updateControlVisibility();
    }
  }

  _updateControlVisibility () {
    if (this._shouldUpdateControlVisibility) {
      this.element.hidden = !this.visible;
    }
  }

  get visible () {
    return this._counter > 0;
  }

}
